import React from 'react';
import classNames from 'classnames';
import { PaymentPlanCardPlaceholder } from '../PaymentPlanCardPlaceholder/PaymentPlanCardPlaceholder';
import { PaymentPlanCard } from '../PaymentPlanCard/PaymentPlanCard';
import cn from './PaymentPlanList.module.scss';

export class PaymentPlanList extends React.PureComponent {
  render() {
    const {
      paymentPlans,
      errors,
      onPaymentPlanChange,
      onPaymentPlanAdd,
      onPaymentPlanDelete,
      onPaymentPlanDefaultChange,
      className,
    } = this.props;
    return (
      <div className={classNames(cn.paymentCards, className)}>
        <input type="hidden" name="paymentPlans" value={JSON.stringify(paymentPlans)} />
        {paymentPlans.map((paymentPlan, index) => (
          <PaymentPlanCard
            key={index}
            error={errors[index]}
            paymentPlan={paymentPlan}
            onPaymentPlanChange={onPaymentPlanChange}
            onPaymentPlanDelete={onPaymentPlanDelete}
            onPaymentPlanDefaultChange={onPaymentPlanDefaultChange}
          />
        ))}
        <PaymentPlanCardPlaceholder onPaymentPlanAdd={onPaymentPlanAdd} />
      </div>
    )
  }
}
